import { Container } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import Sidebar from './components/Sidebar';
import { LoadStatus } from './constants/constants';
import { cookieSignIn, selectAuthenticated } from './redux/reducers/authenticationReducer';
import { initialize as initCatalogs, selectCatalogsLoadStatus } from './redux/reducers/catalogsReducer';
import AssessmentView from './views/AssessmentView';
import HomeView from './views/HomeView';
import FrameworkView from './views/FrameworkView';
import LoginView from './views/LoginView';
import ManageActivitiesView from './views/ManageActivitiesView';
import OrganizationSelectionView from './views/OrganizationSelectionView';
import OrganizationView from './views/OrganizationView';

export default function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authenticated = useSelector(selectAuthenticated);
  const catalogsLoadStatus = useSelector(selectCatalogsLoadStatus);

  useEffect(() => {
    dispatch(cookieSignIn(navigate));
  }, []);

  useEffect(() => {
    if (authenticated && catalogsLoadStatus === LoadStatus.INITIAL) {
      dispatch(initCatalogs());
    }
  }, [catalogsLoadStatus]);

  useEffect(() => {
    if (!authenticated && location.pathname !== '/') {
      navigate('/');
    }
  }, [authenticated, location]);

  return (
    <div className="App">
      <div className="main-page">
        {authenticated && location.pathname !== '/' && location.pathname !== '/selection' && (
          <div className="sidebar-container">
            <Sidebar />
          </div>
        )}
        <Container variant="mainContentArea" maxWidth={false} disableGutters>
          <Routes>
            <Route index element={<LoginView />} />
            <Route path="/" element={<LoginView />} />
            <Route path="/selection" element={authenticated && <OrganizationSelectionView />} />
            <Route path="/home" element={authenticated && <HomeView />} />
            <Route path="/frameworks" element={authenticated && <FrameworkView reset={Math.random()} />} />
            <Route path="/assess" element={authenticated && <AssessmentView />} />
            <Route path="/activities" element={authenticated && <ManageActivitiesView />} />
            <Route path="/organization" element={authenticated && <OrganizationView />} />
          </Routes>
        </Container>
      </div>
    </div>
  );
}
